module.exports = __webpack_public_path__ + "static/media/SWSCRC1-07.a203d504.mp3";